import type { FlowOnlineCountSubscription } from '../gen/flow'
import { useFlowOnlineCountSubscription } from '../gen/flow'
import { useUsersOnlineStore } from './users-online-store'

export function useUsersOnlineCount() {
  const { usersOnline, setUsersOnline } = useUsersOnlineStore()

  useFlowOnlineCountSubscription({
    callback: (data: FlowOnlineCountSubscription | null) => {
      if (typeof data?.flowOnlineCount !== 'number') {
        return
      }

      setUsersOnline(data.flowOnlineCount)
    },
  })

  return usersOnline
}
